import { TRANSACTION_TYPES } from '../utils/constants';

const scopesRoutes = [

    {
        path: '/scopes',
        name: 'ScopesPage',
        component: () => import('../views/scopes/ScopesComponent.vue'),
        meta: {
            requiresAuth: true,
            permission: 'scopes',
            module: 'risksManagement',


        }

    },
    {
        path: '/scopes/create',
        name: 'ScopeCreatePage',
        component: () => import('../views/scopes/ScopesManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['scopes', 'createScope'],
            module: 'risksManagement',


        }

    },
    {
        path: '/scopes/edit/:scopeId',
        name: 'ScopesEditPage',
        component: () => import('../views/scopes/ScopesManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.EDIT, scopeId: route.params.scopeId }),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['scopes', 'editScope'],
            module: 'risksManagement',

        }

    },
    {
        path: '/scopes/show/:scopeId',
        name: 'ScopesShowPage',
        component: () => import('../views/scopes/ScopesManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.SHOW, scopeId: route.params.scopeId }),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: ['scopes', 'viewScope'],
            module: 'risksManagement',

        }

    },
    {
        path: '/scopes/select',
        name: 'ScopesSelectPage',
        component: () => import('../views/auth/SelectScope.vue'),
        meta: {
            
            requiresAuth: true,

        }
    },
];

export default scopesRoutes;